import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * The `data.breadcrumb` label of the deepest active route, or undefined when it declares none.
 * Only the deepest route counts, so a list route's label does not leak onto its `:id` sibling.
 */
export function routeBreadcrumb(root: ActivatedRouteSnapshot | null | undefined): string | undefined {
    let route = root;
    while (route?.firstChild) {
        route = route.firstChild;
    }
    return route?.data?.['breadcrumb'];
}
